<template>
  <section>
    <h1>
      こちらはメインページです。 <br />
      現在のユーザーは, 「{{ username }}」 です。
    </h1>
    <h2>
      社会基盤施設の維持管理を支援しオープンデータの利用・活用を促進するためのサービス連携プラットフォームのプロトタイプです。
    </h2>
  </section>
  <section>
    <h2>サービスを探す</h2>

    <input
      type="text"
      v-model="keyword"
      placeholder="キーワードを入力"
    />

    <select v-model="category">
      <option value="all">すべて</option>
      <option value="システム">システム</option>
      <option value="オープンデータ">オープンデータ</option>
      <option value="API">API</option>
    </select>

    <button @click="goSearch">検索</button>
  </section>
</template>

<script setup>
import { useUserStore } from "../store/user.js";
import { useRouter } from "vue-router";
import { ref } from "vue";

const userStore = useUserStore();
const router = useRouter();

const username = ref(userStore.username);
const keyword = ref("");
const category = ref("all");

userStore.$subscribe(() => {
  username.value = userStore.username;
});

function goSearch() {
  console.log(router.getRoutes().map(r => r.name));
  router.push({
    name: "OpenDataCatalog",
    query: {
      keyword: keyword.value,
      category: category.value
    }
  });
}
</script>

<style scoped>
section {
  margin-left: 350px;
}
h2 {
  font-size: 20px;
  font-weight: normal;
}
</style>
